import React from 'react'

function RememberPassword() {
    return (
        <div>
            
        </div>
    )
}

export default RememberPassword
